import React, { useEffect, useState } from "react";
import FrontendLayout from "../FrontendLayout";
import Menu from "./Menu";
import { GET_BOOKING } from "../../data/url";
import Alert from "../../utils/Alert";
import httpClient from "../../http/HttpRequest";
import Helper from "../../utils/Helper";
import { ORG } from "../../data/costant";

const Txns = () => {
  const [bookings, setBooking] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBookings();
  }, []);

  const getBookings = async () => {
    setLoading(true);
    try {
      const res = await httpClient.post(GET_BOOKING, {});
      if (res.requestStatus === "OK") {
        const result = res.result;
        if (result.status === 1) {
          setBooking(result.data || []);
        } else {
          Alert.error(result.message);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const getStatus = (status) => {
    if (Number(status) === 1) {
      return { label: "SUCCESS", className: "success" };
    }
    if (Number(status) === 2) {
      return { label: "CANCELLED", className: "cancelled" };
    }
    return { label: "PENDING", className: "pending" };
  };

  const bookingStats = {
    total: bookings.length,
    successful: bookings.filter((booking) => Number(booking.status) === 1).length,
    pending: bookings.filter(
      (booking) => ![1, 2].includes(Number(booking.status))
    ).length,
  };

  const escapeHtml = (value) =>
    String(value ?? "-")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  const printReceipt = (booking) => {
    const status = getStatus(booking.status);
    const receiptNo = escapeHtml(booking.order_id || booking.booking_id || booking.id || "N/A");
    const createdAt = escapeHtml(booking.created_at ? Helper.formatDate(booking.created_at) : "-");
    const amount = booking.amount || booking.total_amount || booking.price || booking.cost;
    const receiptWindow = window.open("", "_blank", "width=920,height=760");

    if (!receiptWindow) {
      Alert.error("Please allow popups to print receipt.");
      return;
    }

    receiptWindow.document.write(`
      <!doctype html>
      <html>
        <head>
          <title>Receipt ${receiptNo}</title>
          <style>
            * { box-sizing: border-box; }
            body {
              margin: 0;
              padding: 32px;
              color: #111827;
              background: #eef1f6;
              font-family: Arial, Helvetica, sans-serif;
            }
            .receipt {
              max-width: 820px;
              margin: 0 auto;
              background: #ffffff;
              border: 1px solid #e5e7eb;
              border-radius: 14px;
              overflow: hidden;
              box-shadow: 0 24px 70px rgba(15, 23, 42, .16);
            }
            .receipt-header {
              display: flex;
              justify-content: space-between;
              gap: 24px;
              padding: 30px;
              color: #ffffff;
              background: linear-gradient(135deg, #060315, #1f2937 62%, #FF3E41);
            }
            .brand h1, .receipt-title h2 { margin: 0; }
            .brand h1 { font-size: 24px; letter-spacing: .3px; }
            .brand p, .receipt-title p { margin: 8px 0 0; color: rgba(255,255,255,.78); font-size: 13px; }
            .receipt-title { text-align: right; }
            .receipt-title h2 { font-size: 30px; }
            .status {
              display: inline-block;
              margin-top: 12px;
              padding: 7px 12px;
              border-radius: 999px;
              color: #ffffff;
              background: ${status.className === "success" ? "#15803d" : status.className === "cancelled" ? "#b91c1c" : "#b7791f"};
              font-size: 12px;
              font-weight: 700;
            }
            .receipt-body { padding: 30px; }
            .summary {
              display: grid;
              grid-template-columns: repeat(3, 1fr);
              gap: 14px;
              margin-bottom: 26px;
            }
            .box {
              padding: 16px;
              background: #f8fafc;
              border: 1px solid #edf0f5;
              border-radius: 10px;
            }
            .box span, .detail span { display: block; color: #6b7280; font-size: 12px; text-transform: uppercase; margin-bottom: 6px; }
            .box strong, .detail strong { display: block; color: #111827; font-size: 15px; }
            .details {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 14px;
            }
            .detail {
              padding: 14px 0;
              border-bottom: 1px solid #edf0f5;
            }
            .route {
              grid-column: 1 / -1;
              padding: 18px;
              background: #fff7f7;
              border: 1px solid #ffe1e1;
              border-radius: 10px;
            }
            .route strong { line-height: 1.55; }
            .footer {
              display: flex;
              justify-content: space-between;
              gap: 20px;
              padding: 22px 30px;
              color: #6b7280;
              background: #f8fafc;
              border-top: 1px solid #edf0f5;
              font-size: 12px;
            }
            @media print {
              body { padding: 0; background: #ffffff; }
              .receipt { box-shadow: none; border-radius: 0; }
            }
          </style>
        </head>
        <body>
          <main class="receipt">
            <section class="receipt-header">
              <div class="brand">
                <h1>${escapeHtml(ORG.name)}</h1>
                <p>${escapeHtml(ORG.address)}</p>
                <p>+91 ${escapeHtml(ORG.mobile)} | ${escapeHtml(ORG.email)}</p>
              </div>
              <div class="receipt-title">
                <h2>Receipt</h2>
                <p>Order #${receiptNo}</p>
                <span class="status">${escapeHtml(status.label)}</span>
              </div>
            </section>
            <section class="receipt-body">
              <div class="summary">
                <div class="box"><span>Customer</span><strong>${escapeHtml(booking.name)}</strong></div>
                <div class="box"><span>Mobile</span><strong>${escapeHtml(booking.mobile)}</strong></div>
                <div class="box"><span>Date</span><strong>${createdAt}</strong></div>
              </div>
              <div class="details">
                <div class="route"><span>Route</span><strong>${escapeHtml(booking.pickup_location)}<br>to<br>${escapeHtml(booking.drop_location)}</strong></div>
                <div class="detail"><span>Truck</span><strong>${escapeHtml(booking.truck_name)}</strong></div>
                <div class="detail"><span>Category</span><strong>${escapeHtml(booking.category_name)}</strong></div>
                <div class="detail"><span>Distance</span><strong>${escapeHtml(booking.distance)}</strong></div>
                <div class="detail"><span>Duration</span><strong>${escapeHtml(booking.duration)}</strong></div>
                <div class="detail"><span>Weight</span><strong>${escapeHtml(booking.weight)} ${escapeHtml(booking.weight_type || "")}</strong></div>
                <div class="detail"><span>Amount</span><strong>${amount ? `Rs. ${escapeHtml(amount)}` : "-"}</strong></div>
              </div>
            </section>
            <section class="footer">
              <span>Generated from ${escapeHtml(ORG.web)}</span>
              <span>Thank you for choosing ${escapeHtml(ORG.name)}</span>
            </section>
          </main>
          <script>
            window.onload = function () {
              window.focus();
              window.print();
            };
          </script>
        </body>
      </html>
    `);
    receiptWindow.document.close();
  };

  return (
    <FrontendLayout>
      <div className="account-page">
        <div className="container">
          <Menu
            title="My Bookings"
            subtitle="Track your transport requests, routes, and booking status."
          />
          <div className="booking-stat-grid">
            <div className="booking-stat-card">
              <span className="booking-stat-icon"><i className="fa fa-receipt"></i></span>
              <div><small>Total bookings</small><strong>{bookingStats.total}</strong></div>
            </div>
            <div className="booking-stat-card is-success">
              <span className="booking-stat-icon"><i className="fa fa-check"></i></span>
              <div><small>Confirmed</small><strong>{bookingStats.successful}</strong></div>
            </div>
            <div className="booking-stat-card is-pending">
              <span className="booking-stat-icon"><i className="fa fa-clock"></i></span>
              <div><small>In progress</small><strong>{bookingStats.pending}</strong></div>
            </div>
          </div>
          <div className="account-panel">
            <div className="account-panel-header">
              <div>
                <span className="account-section-label">Booking History</span>
                <h2>Recent Bookings</h2>
              </div>
              <span className="booking-count">{bookings.length} Bookings</span>
            </div>
            <div className="account-panel-body p-0">
              {loading ? (
                <div className="account-empty-state">
                  <i className="fa fa-spinner fa-spin"></i>
                  <h5>Loading bookings</h5>
                </div>
              ) : bookings.length === 0 ? (
                <div className="account-empty-state">
                  <i className="fa fa-clipboard-list"></i>
                  <h5>No bookings found</h5>
                  <p>Your booking history will appear here after you place a request.</p>
                </div>
              ) : (
                <div className="table-responsive account-table-wrap order-table-wrap">
                  <table className="table account-table order-table mb-0">
                    <thead>
                      <tr>
                        <th>Order</th>
                        <th>Customer</th>
                        <th>Route</th>
                        <th>Shipment</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookings.map((row) => {
                        const status = getStatus(row.status);
                        const orderNo = row.order_id || row.booking_id || row.id || "-";
                        return (
                          <tr key={row.id}>
                            <td data-label="Order">
                              <div className="order-cell">
                                <span className="order-id">
                                  <i className="fa fa-hashtag"></i>{orderNo}
                                </span>
                                <span className="order-date">
                                  {row.created_at ? Helper.formatDate(row.created_at) : "-"}
                                </span>
                              </div>
                            </td>
                            <td data-label="Customer">
                              <div className="order-cell">
                                <strong>{row.name || "-"}</strong>
                                <span>{row.mobile || "-"}</span>
                              </div>
                            </td>
                            <td data-label="Route">
                              <div className="route-cell">
                                <span className="route-stop">
                                  <small>Pickup</small>
                                  <strong>{row.pickup_location || "-"}</strong>
                                </span>
                                <i className="fa fa-arrow-right"></i>
                                <span className="route-stop">
                                  <small>Drop</small>
                                  <strong>{row.drop_location || "-"}</strong>
                                </span>
                              </div>
                            </td>
                            <td data-label="Shipment">
                              <div className="order-cell">
                                <strong><i className="fa fa-truck me-2 text-primary"></i>{row.truck_name || "-"}</strong>
                                <span>
                                  {row.category_name || "-"} | {row.weight || "-"}{" "}
                                  {row.weight_type || ""}
                                </span>
                                <span>
                                  {row.distance || "-"} | {row.duration || "-"}
                                </span>
                              </div>
                            </td>
                            <td data-label="Status">
                              <span className={`booking-status ${status.className}`}>
                                {status.label}
                              </span>
                            </td>
                            <td data-label="Action">
                              <button
                                type="button"
                                className="receipt-btn"
                                onClick={() => printReceipt(row)}
                              >
                                <i className="fa fa-print"></i>
                                Print Receipt
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </FrontendLayout>
  );
};

export default Txns;
